export enum DrawerType {
  settingsOpen = 'settingsOpen',
}

interface DrawerParams<DType extends DrawerType> {
  drawerType: DType;
}

export type OpenDrawerParams = DrawerParams<DrawerType.settingsOpen>;
